import Vue from 'vue';
import Router from 'vue-router';
import axiosConfig from './axios';
import store from './store';


 
Vue.use(Router);

const router = new Router({
    // 🎈 @mattia da scommentare quando in produzione, su goku altrimenti non funziona
    //mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: '/login',
            name: 'route-login',
            meta: {
                guest: true
            },
            component: () => import('./views/account/login/ViewLogin.vue')
            
        },
        {
            path: '/',
         
            name: 'route-index',
            component: () => import('./views/contract/list.vue'),
            meta: {
                auth: true,
                label: "Home"
            },
        },
        {
            path: '/tagtype/list',
            name: 'route-tagtype-list',
            meta: {
                auth: true,
                label:"Tipologia tags"
               
            },
            component: () => import('./views/tagtype/list.vue')
        },
        {
            path: '/tagtype/:id',
            name: 'route-tagtype-edit',
            meta: {
                auth: true,
                label:"Tipologia tag"

            },
            component: () => import('./views/tagtype/save.vue')
        },
        {
            path: '/tag/list',
            name: 'route-tag-list',
            meta: {
                auth: true,
                label:"Tags"
            },
            component: () => import('./views/tag/list.vue')
        },
        {
            path: '/tag/:id',
            name: 'route-tag-edit',
            meta: {
                auth: true,
                label:"Tag"

            },
            component: () => import('./views/tag/save.vue')
        },
        {
            path: '/contract/list',
            name: 'route-contract-list',
            meta: {
                auth: true,
                label:"Contratti"

            },
            component: () => import('./views/contract/list.vue')
        },
        {
            path: '/contract/list/:state',
            name: 'route-contract-list-state',
            
            meta: {
                auth: true,
                label:"Contratti"

            },
            component: () => import('./views/contract/filtered.vue')
        },
        {
            path: '/contract/new',
            name: 'route-contract-new',
            meta: {
                auth: true,
                label:"Nuovo contratto"

            },
            component: () => import('./views/contract/insert.vue')
        },
        {
            path: '/contract/:cid/:id?',
            name: 'route-contract-edit',
            meta: {
                auth: true,
                label:"Contratto"

            },
            component: () => import('./views/contract/save.vue')
        }

        ,
        {
            path: '/contract/ty',
            name: 'route-contract-ty',
            meta: {
                auth: true,
                label:"Contratto"

            },
            component: () => import('./views/contract/ty.vue')
        }
      
        ,
        {
            path: '/page/error',
            name: 'route-error',
            meta: {
                guest: true
            },
            component: () => import('./views/pages/ViewError.vue')
        }
        ,
        {
            path: '/inbox',
            name: 'route-inbox',
            meta: {
                auth: true,
                label:"In Box"
            },
            component: () => import('./views/InBox/list.vue')
        },
        {
            path: '/templatecategory',
         
            name: 'route-templatecategory-list',
            component: () => import('./views/templatecategory/list.vue'),
            meta: {
                auth: true,
                label: "Categorie template"
            },
        }
        ,
        {
            path: '/templatecategory/:id?',
         
            name: 'route-templatecategory-edit',
            component: () => import('./views/templatecategory/save.vue'),
            meta: {
                auth: true,
                label: "Categoria template"
            }
        },
        {
            path: '/template',
         
            name: 'route-template-list',
            component: () => import('./views/template/list.vue'),
            meta: {
                auth: true,
                label: "Templates"
            },
        }
        ,
        {
            path: '/template/:id?',
         
            name: 'route-template-edit',
            component: () => import('./views/template/save.vue'),
            meta: {
                auth: true,
                label: "Template"
            }
        },
        {
            path: '/emailtemplate',
         
            name: 'route-emailtemplate-list',
            component: () => import('./views/emailtemplate/list.vue'),
            meta: {
                auth: true,
                label: "Email templates"
            },
        }
        ,
        {
            path: '/emailtemplate/:id?',
         
            name: 'route-emailtemplate-edit',
            component: () => import('./views/emailtemplate/save.vue'),
            meta: {
                auth: true,
                label: "Email Template"
            }
        },
        {
            path: '/signature',
         
            name: 'route-signature-list',
            component: () => import('./views/signature/list.vue'),
            meta: {
                auth: true,
                label: "Firma"
            },
        },
        {
            path: '/signature/:id?',
         
            name: 'route-signature-edit',
            component: () => import('./views/signature/save.vue'),
            meta: {
                auth: true,
                label: "Firma"
            }, 
        }
    ]
});


router.beforeEach((to, from, next) => {

    if (localStorage.getItem('leasing-api')) {
        if (!store.getters.isAuthenticated) {
            store.dispatch('autoLogin');
            
            for (var i = 0; i < store.state.user.roles.length; i++) {
                if (store.state.user.roles[i] == "user") {
                   // isuser = true;
                    break;
                }
            }

        }

    }


    

    if (to.matched.some(record => record.meta.auth)) {
      
        if (!store.getters.isAuthenticated) {
            next({
                path: '/login',
                replace: true
            });
            return;
        }

        store.dispatch('userInfo');
      
    }
   
    next();
});

export default router;
